// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__puhRu","text":"Login_text__gL5XM","action":"Login_action__IIUUr"};